import { MULTIPLE_CHOICE_TYPE } from '@/utils/constants/examConstants'

function isAttributeSelectPerType(typeAttribute) {
	return typeAttribute === MULTIPLE_CHOICE_TYPE
}

export { isAttributeSelectPerType }
